<template>
  <div data-testid="loader" class="loader">
    <v-progress-circular indeterminate color="primary" :size="size" />
  </div>
</template>

<script>
export default {
  name: "Loader",
  props: {
    size: {
      type: Number,
      default: 72,
    },
  },
};
</script>

<style scoped>
.loader {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
</style>
